// extracted by mini-css-extract-plugin
export default {"card":"CardProjeto_card__pJ5t7","icone":"CardProjeto_icone__+LK0p","nome":"CardProjeto_nome__EzOt+","texto":"CardProjeto_texto__mmLbW","botao":"CardProjeto_botao__pP-0r"};